import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import { THEME } from "../../theming/theming";
import { classNames } from "../../utils/classNames";
const SORT_GLYPH_MAP = {
    asc: "menu-up",
    desc: "menu-down",
};
export const TableHeaderCell = ({ sortDirection, title, onSort, sortColumn, headingKey }) => {
    const [showUnsetIcon, setShowUnsetIcon] = useState(false);
    const classes = useStyles();
    return (React.createElement("div", { role: "button", onMouseEnter: () => headingKey !== sortColumn && setShowUnsetIcon(true), onMouseLeave: () => headingKey !== sortColumn && setShowUnsetIcon(false), onClick: () => {
            onSort(headingKey);
            headingKey !== sortColumn && setShowUnsetIcon(false);
        }, onKeyPress: () => {
            onSort(headingKey);
            headingKey !== sortColumn && setShowUnsetIcon(false);
        }, className: classes.button },
        title,
        showUnsetIcon ? (React.createElement("span", { className: classNames(`glyphicon glyphicon-menu-up`, classes.unset, classes.icon) })) : (sortColumn === headingKey &&
            sortDirection && (React.createElement("span", { className: classNames(`glyphicon glyphicon-${SORT_GLYPH_MAP[sortDirection]}`, classes.icon) })))));
};
const useStyles = createUseStyles({
    button: {
        padding: 5,
        position: "relative",
        paddingRight: 19,
    },
    icon: {
        position: "absolute",
        right: 5,
        top: 7,
    },
    unset: {
        color: THEME.palette.gray.cloud.color,
    },
});
